export default __webpack_public_path__ + "static/soehne-web-fett-kursiv-6e5f3dd869f8a9e9025328ef14c944e7.eot";